import en from '@/assets/locales/en'
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import updateLocale from 'dayjs/plugin/updateLocale'
import localeData from 'dayjs/plugin/localeData'

export { default as frLocale } from 'dayjs/locale/fr'
export { default as arLocale } from 'dayjs/locale/ar-sa'
export { default as esLocale } from 'dayjs/locale/es'
export { default as itLocale } from 'dayjs/locale/it'
export { default as ptLocale } from 'dayjs/locale/pt'

export const thresholds = [
  { l: 's', r: 1 },
  { l: 'm', r: 1 },
  { l: 'mm', r: 59, d: 'minute' },
  { l: 'h', r: 1 },
  { l: 'hh', r: 23, d: 'hour' },
  { l: 'd', r: 1 },
  { l: 'dd', r: 29, d: 'day' },
  { l: 'M', r: 1 },
  { l: 'MM', r: 11, d: 'month' },
  { l: 'y', r: 1 },
  { l: 'yy', d: 'year' },
]

export const adapterLocaleMap: Record<string, string> = {
  ar: 'ar-sa',
  'ar-SA': 'ar-sa',
  en: 'en',
  'en-SA': 'en',
  fr: 'fr',
  iv: 'fr',
  es: 'es',
  it: 'it',
  pt: 'pt',
}

/**
 * Resolve an i18n language tag to a dayjs adapter locale, safely.
 *
 * `i18n.language` can be a full tag like `en-US` or `pt`, which are NOT keys of
 * `adapterLocaleMap`. Indexing directly returns `undefined`, and
 * `dayjs(...).locale(undefined)` behaves as a GETTER (returns the locale string,
 * not a dayjs instance) — so a following `.format()`/`.humanize()` throws
 * "format is not a function" and crashes the component. Always go through this:
 * exact match → base subtag (`en-US` → `en`) → `en` fallback.
 */
export const toAdapterLocale = (language?: string): string =>
  adapterLocaleMap[language ?? ''] ?? adapterLocaleMap[(language ?? '').split('-')[0]] ?? 'en'

dayjs.extend(calendar)
dayjs.extend(localeData)
dayjs.extend(updateLocale)

dayjs.updateLocale('en', {
  calendar: {
    sameDay: '[Today]',
  },
})

dayjs.updateLocale('fr', {
  calendar: {
    sameDay: "[Aujourd'hui]",
  },
})

dayjs.updateLocale('ar-sa', {
  calendar: {
    sameDay: '[اليوم]',
  },
})

dayjs.updateLocale('es', {
  calendar: {
    sameDay: '[Hoy]',
  },
})

dayjs.updateLocale('it', {
  calendar: {
    sameDay: '[Oggi]',
  },
})

dayjs.updateLocale('pt', {
  calendar: {
    sameDay: '[Hoje]',
  },
})
